import { ClipboardEvent, ClipboardEventHandler } from 'react';

export const onInputPast = (
  event: ClipboardEvent<HTMLInputElement>,
  onPaste?: ClipboardEventHandler<HTMLInputElement>,
  disablePasting = false,
) => {
  if (disablePasting) {
    event.preventDefault();
  } else if (onPaste !== undefined) {
    onPaste(event);
  }
};
